
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Industries/restaurant-pos-billing-software",
      function () {
        return require("private-next-pages/Industries/restaurant-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Industries/restaurant-pos-billing-software"])
      });
    }
  